/* public-path Sets the cdn path of the chunks.  Must be the first import in this file */
import '~/common/public-path';
import {createRoot} from 'react-dom/client';
import {MegaNavABTest} from '~/common/components/MegaNav/MegaNavABTest';

// Note: each project must set process.env.ASSET_PATH

const container = document.getElementById('meganav');

evite.when(['react', 'site-libraries']).then(() => {
  if (container) {
    const root = createRoot(container);
    root.render(<MegaNavABTest />);
  }
});
